import { ItemDemandRepository } from '../../../item/repositories/item_demand_repository';
import { ItemRequest } from '../models/item_request';
import { ItemRequestJsEnv } from '../models/item_request_js_env';
import { TypedEvent } from '../../../core/typed_event';

export class ItemRequestSubmitAction {
    static readonly UPDATE_EVENT = new TypedEvent<ItemRequestJsEnv>();
    private static state: ItemRequest;
    static async sendItemRequest() {
        const makerName = (<HTMLInputElement>document.getElementById("makername")).value;
        const productname = (<HTMLInputElement>document.getElementById("productname")).value;
        const makermodel = (<HTMLInputElement>document.getElementById("makermodel")).value;
        const jancode = (<HTMLInputElement>document.getElementById("jancode")).value;
        const comment = (<HTMLInputElement>document.getElementById("comment")).value;
        const llCategoryCode = (<HTMLInputElement>document.getElementById("llCategoryCode")).value;
        const lCategoryCode = (<HTMLInputElement>document.getElementById("lCategoryCode")).value;
        const mCategoryCode = (<HTMLInputElement>document.getElementById("mCategoryCode")).value;
        const sCategoryCode = (<HTMLInputElement>document.getElementById("sCategoryCode")).value;
        const searchKeyWord = (<HTMLInputElement>document.getElementById("searchKeyword")).value;
        this.state = new ItemRequest(new ItemRequestJsEnv(
            makerName,
            productname,
            makermodel,
            jancode,
            comment,
            llCategoryCode,
            lCategoryCode,
            mCategoryCode,
            sCategoryCode,
            searchKeyWord
        ));
        const model = this.state.getModel();
        const itemDemandRepository = new ItemDemandRepository();

        itemDemandRepository.create(model).then(() => {
          this.state.setIsSendFailed(false);
          this.state.setIsSendSuccess(true);
          // finallyサポートがないバージョンのため各ブロックでtrigger
          this.UPDATE_EVENT.trigger(this.state.getModel());
        }).catch(() => {
          this.state.setIsSendFailed(true);
          this.state.setIsSendSuccess(false);
          this.UPDATE_EVENT.trigger(this.state.getModel());
        });
    }
}
